var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "34", height: "61", viewBox: "0 0 34 61", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M33.8145 0.0625H24.8145C20.8362 0.0625 17.0209 1.64285 14.2079 4.4559C11.3948 7.26894 9.81445 11.0843 9.81445 15.0625V24.0625H0.814453V36.0625H9.81445V60.0625H21.8145V36.0625H30.8145L33.8145 24.0625H21.8145V15.0625C21.8145 14.2669 22.1305 13.5038 22.6931 12.9412C23.2557 12.3786 24.0188 12.0625 24.8145 12.0625H33.8145V0.0625Z", fill: "#14C17B" })
  );
});